// 編集ロック
import commonClass from './commonClass';

export default class lockClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._prt = '.c-lock';
    this._lockTarget = '.c-lock_target';
    this._beginEdit = '.c-lock_begin-edit';
    this._endEdit = '.c-lock_end-edit';
    this._editingShow = '.c-lock_editing-show';
    this._editingHide = '.c-lock_editing-hide';
    this._prev = '.c-lock_prev';
    this._grandParent = '.c-lock_prt';
    this._sortable = '.js-drag_drop_table,.js-sortable_prt';

    this._$prt = $(this._prt);
    this._$lockTarget = $(this._lockTarget);
    this._$grdPrt = $(this._grandParent);
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // ロック解除
  _unlock(_prt) {
    var cls = this;

    _prt.find(cls._sortable).sortable('disable');  // 行移動の無効化
    $.each(_prt.find('input,select,button,textarea,a'), function (i, e) {
      var _e = $(e);
      if (_e.hasClass('c-lock_before-edit-unlock') || _e.hasClass('c-lock_begin-edit')) {
        _e.removeClass('c-lock_pointer-none').prop('readonly', false);
        return true;
      }
      var type = _e.attr('type');
      if (type) {
        type = type.toLowerCase();
      }
      if (type === 'checkbox' || type === 'radio') {
        var listCheck = _e.closest('.c-lst_chkbox');
        if (listCheck.length > 0) {
          listCheck.addClass('c-lock_pointer-none').prop('readonly', true);
        } else {
          _e.parent().addClass('c-lock_pointer-none').prop('readonly', true);
        }
      }
      else {
        _e.addClass('c-lock_pointer-none').prop('readonly', true);
      }
    });
  }

  // メイン処理
  _main() {
    var cls = this;

    if (cls._$prt.length) {
      // 編集前設定
      cls._unlock(cls._$prt);

      // 編集開始
      $(document).on('click', cls._beginEdit, function () {
        var _this = $(this);
        var _parent = $(this).closest(cls._prt);
        
        // 他項目のロック処理
        cls._$lockTarget.addClass('c-lock_editing-lock');
        _this.closest(cls._lockTarget).removeClass('c-lock_editing-lock');
        _parent.prev(cls._prev).removeClass('c-lock_editing-lock');
        var _grandParent = _parent.closest(cls._grandParent);
        $.each(cls._$grdPrt, function (i, e) {
          var _e = $(e);
          if (!_e.is(_grandParent)) {
            _e.addClass('c-lock_editing-lock');
            _e.find('.c-lock_editing-lock').removeClass('c-lock_editing-lock');
          }
        });

        // 表示切替
        _this.hide();
        _parent.find(cls._editingShow).show();
        _parent.find(cls._editingHide).hide();
        _parent.find(cls._endEdit).css('display', 'inline-block');

        // 操作制御
        _parent.find(cls._sortable).sortable('enable');
        $.each(_parent.find('input,select,button,textarea,a'), function (i, e) {
          var _e = $(e);
          if (_e.hasClass('c-lock_before-edit-unlock')) {
            _e.addClass('c-lock_pointer-none').prop('readonly', true);
            return true;
          }
          var type = _e.attr('type');
          if (type) {
            type = type.toLowerCase();
          }
          if (type === 'checkbox' || type === 'radio') {
            var listCheck = _e.closest('.c-lst_chkbox');
            if (listCheck.length > 0) {
              listCheck.removeClass('c-lock_pointer-none').prop('readonly', false);
            } else {
              _e.parent().removeClass('c-lock_pointer-none').prop('readonly', false);
            }
          }
          else {
            _e.removeClass('c-lock_pointer-none').prop('readonly', false);
          }
        });
      });

      // 編集終了
      $(document).on('click', cls._endEdit, function () {
        var _this = $(this);
        var _parent = $(this).closest(cls._prt);
        
        // 他項目のロック解除
        cls._$lockTarget.removeClass('c-lock_editing-lock');
        cls._$grdPrt.removeClass('c-lock_editing-lock');

        // 表示切替
        _this.hide();
        _parent.find(cls._editingShow).hide();
        _parent.find(cls._editingHide).show();
        _parent.find(cls._beginEdit).show();

        // 操作制御
        cls._unlock(_parent);
      });
    }
  }
}